<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-row class="ma-0 mb-1 pa-0 text-center">
            <v-col cols="3" class="ma-0 pa-0">
                <v-simple-table
                    class="ma-0 pa-0"
                    dense
                >
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-center">불량명</th>
                            <th class="text-center">부적합 건수</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in item" :key="item.name">
                            <td class="ma-0">{{ item.name }}</td>
                            <td class="ma-0 pa-0 pr-10" :style=" { 'text-align': 'right' } ">{{ item.value }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="9" class="ma-0 pa-0">
                <v-spacer/>
                <h1 class="mb-2">출하검사 부적합 원인분석 결과</h1>
                <v-spacer/>
                <canvas width="1170" height="200"
                        id="graph2"
                        class="canvas"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'GraphDataOG2',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    DataList: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    item: [],
    graphWidth: 1170,
    graphHeight: 200,
    MarginLeft: 60,
    MarginRight: 60,
    MarginTop: 10,
    MarginBottom: 18,
    ctx: null,
    max: 0
  }),
  methods: {
    getData () {
      this.item = []
      for (let i = 0; i < this.DataList.length; i++) {
        this.addItem(this.DataList[i].defectedItem1, this.DataList[i].defectedNumber1)
        this.addItem(this.DataList[i].defectedItem2, this.DataList[i].defectedNumber2)
        this.addItem(this.DataList[i].defectedItem3, this.DataList[i].defectedNumber3)
      }
      this.item.sort(this.customSort)

      const maxCount = 8
      while (this.item.length > maxCount) {
        this.item[maxCount - 1].name = '기타'
        this.item[maxCount - 1].value += this.item[maxCount].value
        this.item.splice(maxCount, 1)
      }
    },
    addItem (item, count) {
      if (item === null || item === 'null') return
      if (count === null || count === 'null') return
      if (typeof item === 'undefined') return
      if (typeof count === 'undefined') return
      count = parseInt(count)
      for (let i = 0; i < this.item.length; i++) {
        if (this.item[i].name === item) {
          this.item[i].value += count
          return
        }
      }
      this.item.push({ name: item, value: count })
    },
    customSort (a, b) {
      if (a.value === b.value) {
        return 0
      }
      return a.value < b.value ? 1 : -1
    },
    draw () {
      // 기본 정보 생성.
      this.makeBaseInfo()

      // 배경 클리어.
      this.drawClear()

      // 막대 그리기.
      this.drawDataBar()

      // 목표 그리기.
      this.drawDataLine()

      // 그래프 라인 그리기.
      this.drawGraphLine()
    },
    makeBaseInfo () {
      this.max = 0
      if (this.item.length > 0) {
        this.max = this.item[0].value
      }
    },
    drawClear () {
      // 배경색 처리
      this.ctx.fillStyle = 'white'
      this.ctx.lineWidth = 1
      this.ctx.beginPath()
      this.ctx.fillRect(0, 0, this.graphWidth, this.graphHeight)
      this.ctx.fill()
    },
    drawGraphLine () {
      // 하단 라인
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 1
      this.ctx.strokeStyle = 'black'
      this.ctx.beginPath()
      this.ctx.moveTo(this.MarginLeft, this.graphHeight - this.MarginBottom)
      this.ctx.lineTo(this.graphWidth - this.MarginRight, this.graphHeight - this.MarginBottom)
      this.ctx.stroke()

      // 센터 라인
      this.ctx.beginPath()
      this.ctx.strokeStyle = 'lightGray'
      this.ctx.moveTo(this.MarginLeft, this.graphHeight - this.MarginBottom - ((this.graphHeight - this.MarginBottom - this.MarginTop) / 2))
      this.ctx.lineTo(this.graphWidth - this.MarginRight, this.graphHeight - this.MarginBottom - ((this.graphHeight - this.MarginBottom - this.MarginTop) / 2))
      this.ctx.stroke()

      // top 라인
      this.ctx.beginPath()
      this.ctx.strokeStyle = 'lightGray'
      this.ctx.moveTo(this.MarginLeft, this.MarginTop)
      this.ctx.lineTo(this.graphWidth - this.MarginRight, this.MarginTop)
      this.ctx.stroke()

      // 좌측 라인
      this.ctx.strokeStyle = 'black'
      this.ctx.beginPath()
      this.ctx.moveTo(this.MarginLeft, this.MarginTop)
      this.ctx.lineTo(this.MarginLeft, this.graphHeight - this.MarginBottom)
      this.ctx.stroke()

      // 우측 라인
      this.ctx.beginPath()
      this.ctx.moveTo(this.graphWidth - this.MarginRight, this.MarginTop)
      this.ctx.lineTo(this.graphWidth - this.MarginRight, this.graphHeight - this.MarginBottom)
      this.ctx.stroke()

      // 좌측 정보 0
      this.ctx.stroke()
      this.ctx.strokeStyle = 'black'
      this.ctx.fillStyle = 'black'
      this.ctx.font = '12px 맑은고딕'
      this.ctx.textBaseline = 'middle'
      this.ctx.textAlign = 'right'
      this.ctx.fillText('0', this.MarginLeft - 5, this.graphHeight - this.MarginBottom)

      // 좌측 정보 Max
      this.ctx.fillText(this.max.toFixed(0), this.MarginLeft - 5, this.MarginTop)

      // 우측 정보. 0%
      this.ctx.textBaseline = 'middle'
      this.ctx.textAlign = 'left'
      this.ctx.fillText('0%', this.graphWidth - this.MarginRight + 5, this.graphHeight - this.MarginBottom)

      // 우측 정보. 50%
      this.ctx.fillText('50%', this.graphWidth - this.MarginRight + 5, this.graphHeight - this.MarginBottom - ((this.graphHeight - this.MarginBottom - this.MarginTop) / 2))

      // 우측 정보. 100%
      this.ctx.fillText('100%', this.graphWidth - this.MarginRight + 5, this.MarginTop)

      // 하단 정보.
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'top'
      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / (this.item.length)
      for (let i = 0; i < this.item.length; i++) {
        this.ctx.fillText(this.item[i].name, this.MarginLeft + (distance * i) + (distance / 2), this.graphHeight - this.MarginBottom + 3)
      }
    },
    drawDataLine () {
      this.ctx.fillStyle = 'rgb(125, 167, 217)'
      this.ctx.strokeStyle = 'rgb(0, 0, 0)'
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 2
      this.ctx.beginPath()

      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / this.item.length

      let total = 0
      for (let i = 0; i < this.item.length; i++) {
        total += parseFloat(this.item[i].value)
      }

      let sum = 0
      for (let i = 0; i < this.item.length; i++) {
        sum += parseFloat(this.item[i].value)
        let y = this.getY(sum * this.max / total)
        if (i === 0) {
          this.ctx.moveTo(this.MarginLeft + (distance * i) + (distance / 2), y)
        } else {
          this.ctx.lineTo(this.MarginLeft + (distance * i) + (distance / 2), y)
        }
      }
      this.ctx.stroke()
    },
    drawDataBar () {
      this.ctx.fillStyle = 'rgb(125, 167, 217)'
      this.ctx.strokeStyle = 'rgb(0, 0, 0)'
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 1
      this.ctx.beginPath()
      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / this.item.length
      for (let i = 0; i < this.item.length; i++) {
        let value = parseFloat(this.item[i].value)
        if (value > 0) {
          let y = this.getY(value)
          let height = this.graphHeight - this.MarginBottom - y
          this.ctx.fillRect(this.MarginLeft + (distance * i) + (distance / 2) - 20,
            y,
            40,
            height
          )
        }
      }
      this.ctx.fill()
    },
    getY (value) {
      let height = this.graphHeight - this.MarginTop - this.MarginBottom
      let fY = this.graphHeight - this.MarginBottom
      fY -= value / this.max * height
      return fY
    }
  },
  mounted () {
    document.getElementById('graph2').height = this.graphHeight
    document.getElementById('graph2').width = this.graphWidth
    this.ctx = document.getElementById('graph2').getContext('2d')
    this.getData()
    this.draw()
  },
  created () {
  },
  watch: {
    update () {
      this.getData()
      if (this.ctx === null) return
      this.draw()
    }
  }

}
</script>

<style scoped>
    .canvas {
        border: 1px solid #000;
    }
</style>
